import { useMutation } from '@apollo/client'
import {
  type AttendanceToleranceSettingFragment,
  CreateAttendanceToleranceSettingDocument,
} from 'generated/resources/graphql'

export const useCreateToleranceSetting = () => {
  const [createToleranceSetting, { loading }] = useMutation(
    CreateAttendanceToleranceSettingDocument
  )

  return {
    loading,
    create(variables: AttendanceToleranceSettingFragment) {
      return createToleranceSetting({ variables })
    },
  }
}
